/* Icons on variant options.
 *
 * raftor_webhq draws the variant buttons (.variant-pill, with data-attribute and data-value) on the product page and the cards; this
 * shows each value as its icon alone, for the ones whose attribute is shown as Icons. (Listing cards are drawn by the card engine, which treats
 * such an attribute like Colour: product_card/adapters/webshop.js.) This handles the product page's own pills (website_hq/attribute_sets.py says which, and which icon). The
 * name appears on hover and keyboard focus, and stays in the page for screen readers. Nothing here names an attribute or a product: it is all data from the site.
 *
 * Careful with the observer: it only touches a button it has not handled, and marks it, so adding the icon (a change in the page) cannot
 * set it off again.
 */
(function () {
	"use strict";

	var METHOD = "raftor_websitehq.website_hq.attribute_sets.icons";
	var SAFE = /^\/(assets|files)\/[A-Za-z0-9_.\/ -]+\.(svg|png|webp)$/;
	var cached = null;
	var scheduled = false;

	function fetchIcons() {
		if (cached) return cached;
		cached = new Promise(function (resolve) {
			if (typeof frappe === "undefined" || !frappe.call) return resolve({});
			var done = false;
			function finish(value) {
				if (done) return;
				done = true;
				resolve(value || {});
			}
			frappe.call({ method: METHOD, type: "POST", callback: function (r) { finish(r && r.message); }, error: function () { finish({}); } });
			setTimeout(function () { finish({}); }, 8000);
		});
		return cached;
	}

	function decorate(pill, icons) {
		pill.setAttribute("data-rfhq-icon", "1");
		var address = (icons[pill.getAttribute("data-attribute")] || {})[pill.getAttribute("data-value")];
		if (!address || !SAFE.test(address) || address.indexOf("..") !== -1) return;
		var icon = document.createElement("span");
		icon.className = "rfhq-pill-icon";
		icon.setAttribute("aria-hidden", "true");
		icon.style.setProperty("--rfhq-icon", 'url("' + address + '")');
		var name = pill.getAttribute("data-value");
		var text = document.createElement("span");
		text.className = "rfhq-sr-only";
		while (pill.firstChild) text.appendChild(pill.firstChild);
		pill.appendChild(icon);
		pill.appendChild(text);
		pill.setAttribute("aria-label", name);
		pill.setAttribute("data-rfhq-label", name);
		pill.classList.add("variant-pill--icon");
	}

	function run() {
		scheduled = false;
		var fresh = document.querySelectorAll(".variant-pill:not([data-rfhq-icon])");
		if (!fresh.length) return;
		fetchIcons().then(function (icons) {
			Array.prototype.forEach.call(document.querySelectorAll(".variant-pill:not([data-rfhq-icon])"), function (pill) { decorate(pill, icons); });
		});
	}

	function schedule() {
		if (scheduled) return;
		scheduled = true;
		setTimeout(run, 60);
	}

	function start() {
		schedule();
		new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
	else start();
})();
